import { c as _c } from "react/compiler-runtime";
import { useCallback } from "react";
import { usePathname, useRouter, useSearchParams } from "next/navigation";

/**
 * Section mapping for highlighting within tabs
 */
const SECTION_ELEMENT_IDS: Record<string, string> = {
  demographics: "demographics-section",
  measurements: "measurements-section",
  medications: "medications-section",
  appointments: "appointments-section",
  "medical-notes": "notes-section",
  "forms-documents": "forms-documents-section"
};

/**
 * Hook for navigating to patient tabs and highlighting sections
 */
export function usePatientTabNavigation() {
  const $ = _c(9);
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  let t0;
  if ($[0] !== pathname || $[1] !== router || $[2] !== searchParams) {
    t0 = (patientId, tab) => {
      const params = new URLSearchParams(searchParams.toString());
      params.set("tab", tab);
      const basePath = pathname.includes(`/patient/${patientId}`) ? pathname : `${pathname.split("/patient/")[0]}/patient/${patientId}`;
      router.push(`${basePath}?${params.toString()}`);
    };
    $[0] = pathname;
    $[1] = router;
    $[2] = searchParams;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const navigateToTab = t0;
  const highlightSection = _temp;
  let t1;
  if ($[4] !== navigateToTab) {
    t1 = (patientId_0, tab_0, sectionKey_0) => {
      navigateToTab(patientId_0, tab_0);
      setTimeout(() => {
        highlightSection(sectionKey_0);
      }, 150);
    };
    $[4] = navigateToTab;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const navigateAndHighlight = t1;
  let t2;
  if ($[6] !== navigateAndHighlight || $[7] !== navigateToTab) {
    t2 = {
      navigateToTab,
      highlightSection,
      navigateAndHighlight
    };
    $[6] = navigateAndHighlight;
    $[7] = navigateToTab;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}
function _temp(sectionKey) {
  const elementId = SECTION_ELEMENT_IDS[sectionKey];
  if (!elementId) {
    return;
  }
  const element = document.getElementById(elementId);
  if (!element) {
    return;
  }
  element.scrollIntoView({
    behavior: "smooth",
    block: "start"
  });
  element.classList.add("ai-citation-highlight");
  setTimeout(() => {
    element.classList.remove("ai-citation-highlight");
  }, 2500);
}